import { Box, Button, Typography } from "@mui/material"
import { OrderModel } from "../../models/order";
import TICK_ICON from '../../assets/images/tick_icon.svg';
import { numberFormat } from "../../utils/nunberFormat";
import { calculateOrderProductUnitByCarts } from "../../utils/calculateOrderProductUnitByCarts";
import { SECONDARY_COLOR } from "../../constants/colors";
import ConfirmDialog from "../../components/ConfirmDialog";
import useReadyToShipController from "./controller/readyToShipController";
import { CartsModel } from "../../models/carts";
import { useTranslation } from "react-i18next";

interface Props {
    selectedData: OrderModel,
    onClose: VoidFunction,
    onCloseFormDetail: VoidFunction,
    onRefetchData: () => Promise<void>;
    currentCarts: CartsModel[],
    oriCarts: CartsModel[],
    currentTotalWithDeliveryFee: number
}

const ReadyToShip = ({ selectedData, onClose, onRefetchData, onCloseFormDetail, currentCarts, oriCarts, currentTotalWithDeliveryFee }: Props) => {
    const controller = useReadyToShipController({
        onClose: () => {
            onClose();
            onCloseFormDetail();
        },
        selectedData,
        onRefetchData,
        currentCarts,
        oriCarts
    })
    const { t } = useTranslation("global");
    return <Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{
                display: 'flex', justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                maxWidth: 700,
                padding: 2,
                flexDirection: 'column',
                borderRadius: "16px",
                background: "var(--background-light-paper, #FFF)",
                boxShadow: "0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.20)"
            }}>
                <img src={TICK_ICON} alt="" style={{
                    width: "263px",
                    height: "263px",
                    marginBottom: "10px"
                }} />
                <Typography fontSize="24px">{t("order_page.Congratulations")}</Typography>
                <Typography fontSize="14px">{t("order_page.Order for")} {selectedData?.customer?.profile?.fullName} {t("order_page.is ready to pick!")}</Typography>
                <Box mt={5} sx={{ width: '100%', maxWidth: 350 }}>
                    <Typography sx={{ lineHeight: 2 }} fontSize="20px" color="666">{t("order_page.Order detail")}</Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t('order_page.Order ID')}: <span style={{ fontWeight: 'bold' }}>{selectedData?.orderNo}</span></Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Order number")}: <span style={{ fontWeight: 'bold' }}>{selectedData?.orderNumber}</span></Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Item unit")}: <span style={{ fontWeight: 'bold', backgroundColor: SECONDARY_COLOR, borderRadius: '8px', padding: "5px 10px 5px 10px", color: 'white', minWidth: "87px" }}>{numberFormat(calculateOrderProductUnitByCarts(currentCarts))}</span></Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t("order_page.Total")}: <span style={{ fontWeight: 'bold' }}>{numberFormat(currentTotalWithDeliveryFee)}</span> {t('Kip')}</Typography>
                    <Typography sx={{ lineHeight: 2 }} color="#666" fontSize="16px">{t('order_page.Payment method')}: <span style={{ fontWeight: 'bold', backgroundColor: SECONDARY_COLOR, borderRadius: '8px', padding: "5px 10px 5px 10px", color: 'white', minWidth: "87px" }}>{t(`${selectedData?.paymentMethod}`)}</span></Typography>
                </Box>
                <Box sx={{ width: '100%', mt: 2, mb: 2 }}>
                    <Box sx={{ backgroundColor: '#C8C8C8;', height: "1px" }} />
                </Box>
                <Box sx={{ gap: 2, justifyContent: "center", display: 'flex' }}>
                    <Button onClick={onClose} variant="contained" color="secondary" sx={{ textTransform: 'none', width: "125px", color: 'white' }}>{t("order_page.Back to pack")}</Button>
                    <Button onClick={controller.handleOpenConfirmDialog} variant="contained" color="primary" sx={{ textTransform: 'none', width: "125px", color: 'white' }}>{t("order_page.Ready to ship")}</Button>
                </Box>
            </Box>
        </Box>
        <ConfirmDialog
            open={controller.openConfirmDialog}
            title={t("order_page.Do you want to ship order?")}
            loading={controller.loadingConfirmDialog}
            onCancel={controller.handleCloseConfirmDialog}
            onConfirm={controller.handleAcceptOrder}
        />
    </Box>
}
export default ReadyToShip;